import Image from 'src/components/ui/Image';

import { styledComponent } from 'src/utils/styled';

const ZoomableImage = styledComponent(Image)`
    transition: transform 250ms;
    &:hover {
        transform: scale(1.1);
    }
`;

export default ZoomableImage;
